import { Component } from '@angular/core';

@Component({
  selector: 'brt-accordion-set',
  templateUrl: './accordion-set.component.html',
  styleUrls: ['./accordion-set.component.scss']
})
export class AccordionSetComponent {

}
